var React = require('react');

function Attention (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M506.43 421.536 291.573 49.394c-15.814-27.391-55.327-27.401-71.147 0L5.568 421.536c-15.814 27.391 3.934 61.616 35.574 61.616h429.714c31.629.001 51.394-34.214 35.574-61.616zm-231.609-36.502c0 10.394-8.427 18.821-18.821 18.821s-18.821-8.427-18.821-18.821v-11.239c0-10.394 8.427-18.821 18.821-18.821s18.821 8.427 18.821 18.821v11.239zm0-73.332c0 10.394-8.427 18.821-18.821 18.821s-18.821-8.427-18.821-18.821v-107.89c0-10.394 8.427-18.821 18.821-18.821s18.821 8.427 18.821 18.821v107.89z"}));
}

Attention.defaultProps = {"viewBox":"0 0 511.999 511.999","style":{"enableBackground":"new 0 0 511.999 511.999"},"xmlSpace":"preserve"};

module.exports = Attention;

Attention.default = Attention;
